import { isDefined } from '@sgme/fp';
import type { Action } from 'state/actions';
import * as addonActionTypes from 'state/addonForm/addonForm.actionTypes';
import type { CorrelationsInput, CorrelationsMap } from 'state/quotes/correlations/correlations.model';
import { addOrPatchKey, removeKey } from 'state/utils/collection';

export function correlationsReducer(state: CorrelationsMap = {}, action: Action): CorrelationsMap {
  switch (action.type) {
    case 'CORRELATIONS_CHANGED':
      return addOrPatchKey(state, action.tabId, previousState => ({ ...previousState, ...action.correlations }));
    case 'QUOTE_REMOVED':
    case addonActionTypes.ADDON_QUOTE_REMOVED:
      return removeKey(state, action.tabId);
    case 'QUOTE_RECEIVED':
      return updateCorrelations(state, action.tabId, action.quote.formResult?.values);
    case 'FORM_ENRICHED_DATA_RECEIVED': {
      return updateCorrelations(state, action.formId, action.data);
    }
    case 'QUOTES_REMOVED':
      return removeKey(state, action.tabId);
    case 'SAVE_CORRELATION_INPUTS':
      return addOrPatchKey(state, action.tabId, previousState => ({
        ...previousState,
        saveCorrelation: { status: 'loading' as const, error: undefined },
      }));
    case 'SAVE_CORRELATION_INPUTS_FAILED':
      return addOrPatchKey(state, action.tabId, previousState => ({
        ...previousState,
        saveCorrelation: { status: 'error' as const, error: undefined },
      }));
    case 'SAVE_CORRELATION_INPUTS_SUCCEEDED':
      return addOrPatchKey(state, action.tabId, previousState => ({
        ...previousState,
        saveCorrelation: { status: 'success' as const, error: undefined },
      }));
    default:
      return state;
  }
}

type DataMap = Record<string, Readonly<unknown>>;
function updateCorrelations(state: CorrelationsMap, tabId: string, data?: DataMap) {
  const timeSeriesGraph = data?.['TimeSeriesGraph'] as { inputs: CorrelationsInput };

  return isDefined(timeSeriesGraph)
    ? addOrPatchKey(state, tabId, previousState => ({
        ...previousState,
        ...timeSeriesGraph.inputs,
      }))
    : state;
}
